import type { ReactNode } from 'react';

import {
  HomeOutline,
  StocksOutline,
  DiscoverOutline,
  WatchlistOutline,
  ScreenerOutline,
  PortfolioOutline,
  HomeSolid,
  StocksSolid,
  DiscoverSolid,
  WatchlistSolid,
  ScreenerSolid,
  PortfolioSolid,
} from '@simplywallst/ui-core/icons';

import {
  ROUTE_DEPRECATED_PORTFOLIO,
  ROUTE_DEPRECATED_PORTFOLIO_EDIT,
  ROUTE_INVESTING_IDEA_MARKET,
  ROUTE_INVESTING_IDEA_MARKET_INDUSTRY,
  ROUTE_INVESTING_IDEA_DISCOVERY_PAGE,
  ROUTE_CREATE_CRITERIA,
  ROUTE_DEPRECATED_PORTFOLIO_LIST,
  ROUTE_DASHBOARD,
  ROUTE_DASHBOARD_WITH_EVENTS,
  ROUTE_DEPRECATED_PORTFOLIO_HOME,
  ROUTE_COMMUNITY_IDEA,
  ROUTE_DISCOVER_INVESTING_IDEAS,
  ROUTE_DEPRECATED_USER_PORTFOLIOS,
  ROUTE_DISCOVER_SAMPLE_PORTFOLIOS,
  ROUTE_DEPRECATED_PUBLIC_PORTFOLIO,
  ROUTE_DEPRECATED_PORTFOLIO_SHARE,
  ROUTE_EDIT_USER_IDEA,
  ROUTE_EDIT_EXPLORE_IDEA,
  ROUTE_DEPRECATED_PORTFOLIO_EDIT_TXN,
  ROUTE_DEPRECATED_PORTFOLIO_RETURNS_REPORT,
  ROUTE_HOME,
  ROUTE_WATCHLIST,
  ROUTE_MARKET,
  ROUTE_MARKET_HOME,
  ROUTE_MARKET_SECTOR,
  ROUTE_MARKET_SECTOR_SECONDARY_TERTIARY,
  ROUTE_MARKET_SECTOR_SECONDARY,
  ROUTE_PORTFOLIO,
  ROUTE_PORTFOLIO_NEW,
  ROUTE_PORTFOLIO_DEFAULT,
} from '@/constants/routes';

interface Route {
  to: string;
  label: string;
  matches: string[];
  icon: ReactNode[];
}

export const routes: Route[] = [
  {
    to: ROUTE_HOME,
    label: 'Dashboard',
    matches: [ROUTE_DASHBOARD, ROUTE_DASHBOARD_WITH_EVENTS],
    icon: [<HomeSolid />, <HomeOutline />],
  },
  {
    to: ROUTE_MARKET_HOME,
    label: 'Markets',
    matches: [
      ROUTE_MARKET,
      ROUTE_MARKET_HOME,
      ROUTE_MARKET_SECTOR,
      ROUTE_MARKET_SECTOR_SECONDARY_TERTIARY,
      ROUTE_MARKET_SECTOR_SECONDARY,
    ],
    icon: [<StocksSolid />, <StocksOutline />],
  },
  {
    to: ROUTE_DISCOVER_INVESTING_IDEAS,
    label: 'Discover',
    matches: [
      ROUTE_DISCOVER_INVESTING_IDEAS,
      ROUTE_DISCOVER_SAMPLE_PORTFOLIOS,
      ROUTE_INVESTING_IDEA_MARKET,
      ROUTE_INVESTING_IDEA_MARKET_INDUSTRY,
      ROUTE_INVESTING_IDEA_DISCOVERY_PAGE,
      ROUTE_COMMUNITY_IDEA,
      ROUTE_DEPRECATED_PUBLIC_PORTFOLIO,
      ROUTE_DEPRECATED_PORTFOLIO_SHARE,
    ],
    icon: [<DiscoverSolid />, <DiscoverOutline />],
  },
  {
    to: ROUTE_WATCHLIST,
    label: 'Watchlist',
    matches: [ROUTE_WATCHLIST],
    icon: [<WatchlistSolid />, <WatchlistOutline />],
  },
  {
    to: ROUTE_DEPRECATED_PORTFOLIO_LIST,
    label: 'Portfolios',
    matches: [
      ROUTE_PORTFOLIO,
      ROUTE_PORTFOLIO_NEW,
      ROUTE_PORTFOLIO_DEFAULT,
      ROUTE_DEPRECATED_PORTFOLIO_LIST,
      ROUTE_DEPRECATED_USER_PORTFOLIOS,
      ROUTE_DEPRECATED_PORTFOLIO,
      ROUTE_DEPRECATED_PORTFOLIO_EDIT,
      ROUTE_DEPRECATED_PORTFOLIO_HOME,
      ROUTE_DEPRECATED_PORTFOLIO_EDIT_TXN,
      ROUTE_DEPRECATED_PORTFOLIO_RETURNS_REPORT,
    ],
    icon: [<PortfolioSolid />, <PortfolioOutline />],
  },
  {
    to: ROUTE_CREATE_CRITERIA,
    label: 'Screener',
    matches: [
      ROUTE_CREATE_CRITERIA,
      ROUTE_EDIT_USER_IDEA,
      ROUTE_EDIT_EXPLORE_IDEA,
    ],
    icon: [<ScreenerSolid />, <ScreenerOutline />],
  },
];
